import originalSidebar from 'src/const/layouts'
const TreeModel = require('tree-model');
const nodeTree = new TreeModel({childrenPropertyName: "children_detail"})

export const userInfo = (state) => {
  return state.userInfo
}
export const nodes = (state) => {
  const copyNodes = JSON.parse(JSON.stringify(state.nodes));
  sortNodes(copyNodes)
  return copyNodes
}

const sortNodes = (targets) => {
  targets.sort((a, b) => sortNodeOrder(a, b))
  for (const key in targets) {
    sortChildNodes(targets[key].children_detail)
  }
}
const sortChildNodes = (targets) => {
  if (targets.length > 0) {
    targets.sort((a, b) => sortNodeOrder(a, b))
    for (const key in targets) {
      sortChildNodes(targets[key].children_detail)
    }
  }
}

const sortNodeOrder = (a, b) => {
  if (a.node_order === null || a.node_order === '') {
    a.node_order = 'z'
  }
  if (b.node_order === null || b.node_order === '') {
    b.node_order = 'z'
  }

  if (a.node_order < b.node_order) return -1;
  if (a.node_order > b.node_order) return 1;
  if (a.id < b.id) return -1;
  if (a.id > b.id) return 1;
  return 0;
}

export const nodesTree = (state) => {
  return nodeTree.parse({id: null, name: null, children_detail: state.nodes})
}
export const node = (state) => (id, includeAncestor = false, returnNull = false) => {
  if (!state.nodes) {
    return {}
  }
  if (!id) {
    return state.defaultNode
  }
  const copyNodes = JSON.parse(JSON.stringify(state.nodes));
  sortNodes(copyNodes)
  const root = nodeTree.parse({id: null, name: null, children_detail: copyNodes});
  const node = root.first(function (x) {
    return x.model.id === parseInt(id);
  });
  if (node === undefined) {
    if (returnNull)
      return null
    else
      return state.defaultNode
  }
  if (includeAncestor) {
    const ancestors = node.getPath().map(x=>x.model).slice(1)
    return ancestors
  } else {
    return node.model
  }
}
export const nodeId = (state) => {
  return state.nodeId
}
export const defaultNode = (state) => {
  return state.defaultNode
}
export const organization = (state) => {
  return state.organization
}
export const userRole = (state) => {
  if (state.userInfo.user_role) {
    return state.userInfo.user_role
  } else {
    return null
  }
}
export const isLoaded = (state) => {
  return state.isLoaded
}

export const dashboardUrl = (state) => {
  // 初期表示用URL
  if (state.userInfo && state.userInfo.favorite_page) {
    return state.userInfo.favorite_page
  }
  return '/top'
}

export const apiClient = (state) => {
  return state.apiClient
}

export const isDisable = (state) => {
  return state.isDisable
}
